<template>
  <ul class="treeMoudel">
    <li
      v-for="(item, index) in menus"
      :key="index"
      class="tree_li"
    >
      <!-- 遍历menus，如果传过来的depth等于0，就添加top_node的class，如果不等于0，就添加no_top_node的class -->
      <div
        :class="{'itemTree':true,'top_node':depth == 0,'no_top_node':depth != 0,'active':actId == item.key}"
        @click="selectItem(item)"
      >
        <span
          v-if="item.title"
          :style="transform"
          :class="{'span_child': true,'top_span':depth == 0,'no_top_span':depth != 0}"
        >
          <!-- 自定义checkbox -->
          <i
            :class="{'select_box':true, 'check_box': item.selectArr.length > 0}"
            @click="checkItem(item)"
          >
            <!-- 如果item的selectArr.length是大于0的，也就是里面有值的话就是勾选状态，否则就是不勾选状态 -->
            <i :class="{'check_top_name iconfont':true, 'iconicon-test16':item.selectArr.length > 0}" />
          </i>
          <span
            class="tree_title"
            v-text="item.title"
          />
        </span>
        <span
          v-if="item.children && item.children.length > 0"
          class="operate_icon"
        >
          <!-- 如果item有孩子且item.show为false,那么图标为折叠图标 -->
          <i
            v-if="!item.show"
            class="iconfont iconicon-test18 to_selected"
          />
          <!-- 如果item有孩子且item.show为true,那么图标为展开图标 -->
          <i
            v-if="item.show"
            class="iconfont iconicon-test17 to_selected"
          />
        </span>
      </div>
      <Tree
        v-if="'children' in item && item.children.length > 0 && item.show"
        :menus="item.children"
        :depth="depth + 3"
        :act-id="actId"
        @selectItem="selectItem"
        @checkItem="checkItem"
      />
    </li>
  </ul>
</template>
<script>
export default {
  name: 'Tree',
  props: {
    menus: {
      type: Array,
      default: () => ({})
    },
    depth: {
      type: Number,
      default: 0
    },
    actId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      checkArr: []
    }
  },
  computed: {
    // 通过传过来的depth计算下级目录的偏移量
    transform () {
      return 'transform:translateX(' + this.depth * 10 + 'px)'
    }
  },
  methods: {
    // 将selectItem方法暴露出去
    selectItem (item) {
      this.$emit('selectItem', item)
    },
    // 将checkItem方法暴露出去
    checkItem (item) {
      this.$emit('checkItem', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.treeMoudel {
  width: 100%;
  background: #fff;
  .tree_li {
    .itemTree {
      position: relative;
      width: 100%;
      line-height: 48px;
      background: #fff;
      .check_box {
        background: #5077AA !important;
        border: none !important
      }
      .select_box {
          display: inline-block;
          width: 16px;
          height:16px;
          border:1px solid #ccc;
          border-radius: 3px;
          position: relative;
          background: #fff;
          top: 2px;
          left: 12px;
          .check_top_name {
            position: absolute;
            top: -15px;
            left: 0;
            color: #fff;
          }
          .check_name {
            position: absolute;
            top: -15px;
            color:#333;
          }
      }
      span {
        display: inline-block;
      }
      .span_child:not(:last-of-type) {
        width: 100%;
        border-bottom: 1px solid #dbdbdb
      }
      .span_child {
        .check_top_name {
          transition: all .4s
        }
      }
      .top_span, .no_top_span {
        font-size:16px;
        .tree_title {
          margin-left: 20px;
        }
      }
      .operate_icon {
        position: absolute;
        right: 19px;
        color: #ccc;
        .to_selected {
          animation: selected .3s;
        }
        @keyframes selected {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      }
    }
    .top_node {
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      border-bottom: 1px solid #dbdbdb
    }
    .active{
      /* background:#2B9EEE;
      color:#fff; */
    }
    .no_top_node{
      line-height: 48px;
    }
  }
}
</style>
